import styled from '@emotion/styled';

export const FontToolBorder = styled.div`
  height: 25px;
  margin: 10px 0px 0px 0px;
  border: solid 1px #e0e0e0;
  background-color: #e0e0e0;
`;

export const TextColorMenu = styled.div`
  width: 121px;
  height: 32px;
  padding: 9px 7px;
  box-shadow: 1px 1px 4px 0 rgba(0, 0, 0, 0.35);
  background-color: white;
`;
